import WebView from '@components/ui/web-view/web-view';
export default WebView;
